
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { MapDispatchToProps, MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { SessionUserSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { contentCountsRequest } from '~src/spacesPlatform/actions/ContentCountsActions';
import { selectContentCounts, selectContentCountsUpToDate } from '~src/spacesPlatform/selectors/ContentCountsSelector';
import { selectSpaceInfo } from '~src/spacesPlatform/selectors/SpaceInfoSelectors';

import { AppState } from '../../../../bootstrap/redux/state/AppState';
import { addGroupsToGroupSet, deleteGroupSets } from '../../actions/GroupSetMenuActions';
import { GroupSetSpace, GroupSetSpaceDispatchProps, GroupSetSpaceStateProps } from './GroupSetSpace';

const mapStateToProps: MapStateToProps<GroupSetSpaceStateProps> = (state: AppState) => ({
  spaceInfo: selectSpaceInfo(state),
  contentCounts: selectContentCounts<'groupset'>(state, 'groupset'),
  contentCountsUpToDate: selectContentCountsUpToDate(state),
  canSessionUserManageUsers: SessionUserSelectors.canManageUsers(state),

});

const mapDispatchToProps: MapDispatchToProps<GroupSetSpaceDispatchProps> =
  (dispatch) => bindActionCreators({
    fetchUpdatedContentCounts: contentCountsRequest,
    deleteGroupSets: () => deleteGroupSets,
    addGroupsToGroupSet: addGroupsToGroupSet
  },
  dispatch);

export const ConnectedGroupSetSpace = connect(mapStateToProps, mapDispatchToProps)(GroupSetSpace);
